import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EdgeDeviceDataService {

  private memoryInfo: Map<string, any> = new Map<string, any>()
  
  
  public get MemoryInfo(): Map<string, any> {
    return this.memoryInfo
  }

  public DeviceMemoryInfo(deviceId?: string): any {
    return this.has(deviceId) ? this.memoryInfo.get(deviceId!) : this.createEmpty()
  }

  public has(key: string | undefined): boolean {
    return !!key && this.memoryInfo.has(key)
  }


  public set(key: string, value: any){
    this.memoryInfo.set(key, value)
  }

  private createEmpty(): any {
    const memoryInstance = {
      total: 0,
      used: 0,
      available: 0,
      free: 0,
      percent: 0,
      buffers: 0,
      cached: 0,
      shared: 0
    }

    return memoryInstance
  }


}
